//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vHTML from '~/mixins/vHTML'

export default {
  name: 'VCheckbox',
  mixins: [vHTML],
  props: {
    value: {
      type: [Boolean, String, null],
      default: null
    },
    val: {
      type: [Boolean, null],
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => {
      }
    },
    errors: {
      type: Array,
      default: () => []
    },
    field: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    errorTextRules: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    subText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      checkedProxy: null
    }
  },
  computed: {
    getSubText () {
      if (this.hasErrorText) {
        return
      }
      return this.subText
    },
    getInputClasses: app => (name, params = null) => {
      const obj = {}
      obj[`${name}--required`] = !!app.required
      obj[`${name}--error`] = !!app.hasErrors
      obj[`${name}--disabled`] = !!app.readonly
      obj[`${name}--prefix`] = !!app.prefix
      obj[`${name}--prefix-${app.prefixPos}`] = !!app.prefix && !!app.prefixPos

      return [obj]
    },
    checked: {
      get () {
        return this.value
      },
      set (val) {
        if (!val) {
          this.checkedProxy = null
          return
        }
        this.checkedProxy = val
      }
    },
    hasErrors () {
      if (this.errors.length) {
        return true
      }
      return this.form && this.form.errors.has(this.field ? this.field : this.name)
    },
    hasErrorText () {
      const showRules = this.errorTextRules.split('|')
      if (showRules.includes('no-require') && ['', null, undefined, false, []].includes(this.value) && this.required) {
        return false
      }
      if (showRules.includes('blur') && !this.input.isBlur) {
        return false
      }
      if (showRules.includes('focus') && !(this.input.isFocus || this.input.isBlur)) {
        return false
      }
      if (this.errors && this.errors[0]) {
        return this.errors[0]
      }
      return this.form && this.form.errors.has(this.field ? this.field : this.name) && this.form.errors.get(this.field ? this.field : this.name)
    },
    getErrorText () {
      if (this.errors && this.errors[0]) {
        return this.errors[0]
      }
      if (this.hasErrorText) {
        return this.form.errors.get(this.field ? this.field : this.name)
      }
      return ''
    }
  },
  methods: {
    onChange (e) {
      if (!this.checkedProxy) {
        this.$emit('input', null)
        return
      }
      this.$emit('input', !!this.checkedProxy)
    },
    setValue (value) {
      this.checked = value
    }
  }
}
